import { useI18n } from '@/i18n';
import StatusChip from '@/components/StatusChip';
import { variboxStatusConfig, type VariboxStatusKey } from '@/data/variboxMockData';

interface VariboxStatusBadgeProps {
  status: VariboxStatusKey;
}

export default function VariboxStatusBadge({ status }: VariboxStatusBadgeProps) {
  const { t } = useI18n();
  const config = variboxStatusConfig[status];

  return <StatusChip label={t(config.labelKey)} tone={config.tone} />;
}
